import { render, staticRenderFns } from "./BaseScreenTab.vue?vue&type=template&id=9c7ac962&scoped=true&"
import script from "./BaseScreenTab.vue?vue&type=script&lang=js&"
export * from "./BaseScreenTab.vue?vue&type=script&lang=js&"
import style0 from "./BaseScreenTab.vue?vue&type=style&index=0&id=9c7ac962&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7ac962",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VIcon,VSnackbar})
